"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.IconLabel = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon/Icon");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable react/jsx-props-no-spreading */

const IconLabel = props => {
  const {
    id,
    leftIcon,
    rightIcon,
    text,
    lblContainerCssModifier,
    containerCssModifier
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: `ccl-e-icon-label ccl-e-icon-label--${containerCssModifier}`,
    children: [leftIcon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      ...leftIcon
    }), text && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      "data-nw-icon-label": id,
      className: `ccl-e-icon-label__text ccl-e-icon-label__text--${lblContainerCssModifier}`,
      children: text
    }), rightIcon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      ...rightIcon
    })]
  });
};
exports.IconLabel = IconLabel;
IconLabel.defaultProps = {
  id: '',
  leftIcon: null,
  rightIcon: null,
  text: '',
  containerCssModifier: 'centered',
  lblContainerCssModifier: 'mobile-hidden'
};